import { render, staticRenderFns } from "./RedirectModal.vue?vue&type=template&id=6bca1ffd&"
import script from "./RedirectModal.vue?vue&type=script&lang=js&"
export * from "./RedirectModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports